import { Flex, Input, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { isGuid } from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"

import type { GuidInputProps } from "./CopilotStudioConnection.types"

export const GuidInput = (props: GuidInputProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.copilotStudio.fields"
  })
  const invalid = !!props.value && !isGuid(props.value)

  return (
    <Flex vertical gap={4}>
      <Text>{props.label}</Text>
      <Input
        value={props.value}
        aria-label={props.label}
        status={invalid ? "error" : undefined}
        placeholder="00000000-0000-0000-0000-000000000000"
        onChange={(e) => props.onChange(e.target.value)}
      />
      {invalid && <Text type="danger">{t("guidError")}</Text>}
    </Flex>
  )
}
